import { toast as sonnerToast } from "sonner";

export const toast = {
  success: (message, options) =>
    sonnerToast.success(message, {
      style: {
        background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
        border: "1px solid rgba(67, 233, 123, 0.3)",
        // boxShadow: "0px 0px 5px rgba(67, 233, 123, 0.3)",
        color: "white",
      },
      ...options,
    }),

  error: (message, options) =>
    sonnerToast.error(message, {
      style: {
        background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
        border: "1px solid rgba(255, 71, 87, 0.3)",
        // boxShadow: "0px 0px 5px rgba(255, 71, 87, 0.3)",
        color: "white",
      },
      ...options,
    }),

  info: (message, options) =>
    sonnerToast.info(message, {
      style: {
        background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
        border: "1px solid rgba(102, 126, 234, 0.3)",
        // boxShadow: "0px 0px 5px rgba(102, 126, 234, 0.3)",
        color: "white",
      },
      ...options,
    }),

  warning: (message, options) =>
    sonnerToast.warning(message, {
      style: {
        background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
        border: "1px solid rgba(255, 193, 7, 0.3)",
        // boxShadow: "0px 0px 5px rgba(255, 193, 7, 0.3)",
        color: "white",
      },
      ...options,
    }),

  loading: (message, options) =>
    sonnerToast.loading(message, {
      style: {
        background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        // boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.3)",
        color: "white",
      },
      ...options,
    }),

  custom: (message, options) =>
    sonnerToast(message, {
      style: {
        background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        // boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.3)",
        color: "white",
      },
      ...options,
    }),

  promise: (promise, options) =>
    sonnerToast.promise(promise, {
      loading: {
        style: {
          background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          // boxShadow: "0px 0px 5px rgba(255, 255, 255, 0.3)",
          color: "white",
        },
      },
      success: {
        style: {
          background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
          border: "1px solid rgba(67, 233, 123, 0.3)",
          // boxShadow: "0px 0px 5px rgba(67, 233, 123, 0.3)",
          color: "white",
        },
      },
      error: {
        style: {
          background: "linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%)",
          border: "1px solid rgba(255, 71, 87, 0.3)",
          // boxShadow: "0px 0px 5px rgba(255, 71, 87, 0.3)",
          color: "white",
        },
      },
      ...options,
    }),

  dismiss: sonnerToast.dismiss,
  message: sonnerToast.message,
};
